export const GET_NOTIFICATIONS_LIST_REQUEST = 'GET_NOTIFICATIONS_LIST_REQUEST';
export const GET_NOTIFICATIONS_LIST_SUCCESS = 'GET_NOTIFICATIONS_LIST_SUCCESS';
export const GET_NOTIFICATIONS_LIST_ERROR = 'GET_NOTIFICATIONS_LIST_ERROR';
export const GET_NOTIFICATIONS_COUNT_REQUEST =
  'GET_NOTIFICATIONS_COUNT_REQUEST';
export const GET_NOTIFICATIONS_COUNT_SUCCESS =
  'GET_NOTIFICATIONS_COUNT_SUCCESS';
export const GET_NOTIFICATIONS_COUNT_ERROR = 'GET_NOTIFICATIONS_COUNT_ERROR';
export const MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST =
  'MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST';
export const MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS =
  'MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS';
export const MARK_ALL_NOTIFICATIONS_AS_READ_ERROR =
  'MARK_ALL_NOTIFICATIONS_AS_READ_ERROR';
export const REFRESH_NOTIFICATIONS_LIST_SUCCESS =
  'REFRESH_NOTIFICATIONS_LIST_SUCCESS';
